import { MUIGrid } from '../../Shared'
import CopyTextTooltip from '../../Shared/CopyTextTooltip'
import { DeleteIcon } from '../../Icons'
import { PAGE_URL, PageNames } from '../../../Constants/PagesRoutes/PageURLs'
import { BOLT_MODULE } from '../../../Constants/Roles'
import { CONSTANTS } from '../../../Constants/Constant'
import {
  checkRolePermissionOnLinkClick,
  getDateInFormat,
  disableButtonBasedOnRole,
} from '../../../Helpers/Util'
import { IKeyValue } from '../../../Models/CommonListHeadingModal'
import style from '../../Molecule/Molecule.module.scss'
import headerStyles from './HeaderComponent.module.scss'
import {
  displayArrayItemValue,
  renderArrayValue,
} from '../../Molecule/CategoryFormData/CommonHelperFunctions'
import { HeaderContentProps } from '../../../Models/HeaderComponent'

const { DATE_N_TIME_FORMAT_SECONDS, DISABLE_DELETE_BUTTON } = CONSTANTS

export default function HeaderContent({
  headerData,
  navigate,
  onDeleteIconClick,
  isDeleted,
  status = 'NA',
  layout = 'NA',
}: HeaderContentProps) {
  const pathArray = globalThis.location.pathname.split('/')
  const moduleAccess = disableButtonBasedOnRole(pathArray[1])
  const canDelete =
    !DISABLE_DELETE_BUTTON.includes(status?.toLowerCase()) &&
    !DISABLE_DELETE_BUTTON.includes(layout?.toLowerCase())

  const getContentValues = (
    value?: string | number | IKeyValue[],
    type?: string,
    title?: string,
    maxCount?: number,
    toolTipWidth?: string,
  ) => {
    if (!value) return 'NA'

    if (type === 'date' && typeof value === 'string')
      return getDateInFormat(value, DATE_N_TIME_FORMAT_SECONDS)

    if (Array.isArray(value))
      return renderArrayValue({
        idKeyToCheck: 'segmentId',
        onClick: (e) =>
          checkRolePermissionOnLinkClick(e, BOLT_MODULE.MANAGE_SEGMENTS.key, navigate),
        pageURI: PAGE_URL[PageNames.Segment],
        value,
        title,
        maxCount,
        testId: 'header_segment_value',
        tooltipModalTitle: 'Segments',
      })

    if (maxCount !== undefined && typeof value === 'string') {
      return displayArrayItemValue(value, maxCount || 25, toolTipWidth || '238px')
    }

    const isIdField = title && /id$/i.test(title.trim())
    if (isIdField && value !== 'NA') {
      return <CopyTextTooltip child={String(value)} />
    }

    return String(value)
  }

  const dynamicContentMuiGrid = (data: any) => {
    if (!data || data.length === 0) {
      return null
    }

    return data.map((header: any) => {
      const { title, value, type, maxCount, toolTipWidth } = header

      return (
        <MUIGrid key={title} xs={6} lg={4}>
          <p className={`${headerStyles.headerDataWrapper}`}>
            <span style={{ fontWeight: '400', marginRight: '0.25rem' }} className={'col34'}>
              {`${title} :`}
            </span>
            <span className={`col36 ${style.header_value}`}>
              {getContentValues(value, type, title, maxCount, toolTipWidth)}
            </span>
          </p>
        </MUIGrid>
      )
    })
  }

  return (
    <MUIGrid
      container
      columnSpacing={2}
      rowSpacing={2}
      className={`d-inline-block ${style.asset_header_dynamic_bottom}`}
      style={{ width: '100%', margin: 'auto' }}
    >
      {dynamicContentMuiGrid(headerData)}
      {onDeleteIconClick && !isDeleted && (
        <div
          aria-hidden={true}
          onClick={() => {
            if (!moduleAccess && canDelete) onDeleteIconClick()
          }}
          className={`col37 d-flex align-items-center ${headerStyles.deleteIcon} ${
            !moduleAccess && canDelete ? 'cursor-pointer' : 'disabled'
          }`}
          data-testid={
            !moduleAccess && canDelete ? 'deleteIcon__test' : 'deleteIcon__test_disabled'
          }
        >
          <DeleteIcon />
        </div>
      )}
    </MUIGrid>
  )
}
